import React, { Component } from 'react';

import styles from './styles.module.css';

import Header from '../../../components/Header';
import Modal from '../../../components/Modal';
import ModalConfirm from '../../../components/ModalConfirm';
import Button from '../../../components/Buttons/Button';

import api from '../../../services/api';
import { API_GUARD } from '../../../services/env';

export default class Plans extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      plans: [],

      isAlertOn: false,
      isExclusionConfirmOn: false,
      marked_plan_id: null,
      modalConfirm: {
        title: "",
        text: ""
      },
      alertMessage: {
        title: "",
        message: ""
      }
    }
    this.getPlans = this.getPlans.bind(this);
    this.toggleConfirm = this.toggleConfirm.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
  }

  componentDidMount() {
    this.getPlans();
  }

  toggleIsLoad(boolean) {
    this.setState({ isLoading: boolean });
  }

  toggleAlert(boolean) {
    this.setState({
      isAlertOn: boolean,
    });
  }

  activeAlert(alertMessage) {
    const { title, message } = alertMessage;
    this.setState({
      ...this.state,
      isAlertOn: true,
      alertMessage: {
        title: title ? title : "",
        message
      }
    });
  }

  async getPlans() {
    try {
      this.toggleIsLoad(true);
      const access_token = await localStorage.getItem("access_token");
      const url = `/v1/${API_GUARD}/plan`;
      const response = await api.get(url, {
        headers: { Authorization: "Bearer " + access_token }
      });
      if (response.status && response.status === 200) {
        const { plans } = response.data;
        this.setState({ plans });
      }
    } catch (error) {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            const { message } = error.response.data;
            this.setState({
              message
            });
            break;
          case 422:
            const { errors } = error.response.data;
            for (let key in errors) {
              this.setState({
                validate: {
                  ...this.state.validate,
                  [key]: {
                    message: errors[key],
                    isInvalid: true
                  }
                }
              });
            }
            break;
          default:
            this.error();
        }
      }
    }
    this.toggleIsLoad(false);
  }

  toggleConfirm(branch) {
    if (branch) {
      const { id, name } = branch;
      this.setState({
        marked_plan_id: id,
        isExclusionConfirmOn: !this.state.isExclusionConfirmOn,
        modalConfirm: {
          title: "Excluir Plano",
          message: `Tem certeza que deseja excluir o plano: ${name}?`
        }
      });
    } else {
      this.setState({
        marked_branch_id: null,
        isExclusionConfirmOn: false,
        modalConfirm: {
          title: "",
          message: ""
        }
      });
    }
  }

  handlerConfirm() {
    const id = this.state.marked_plan_id;
    this.handlerDestroyPlan(id);
  }

  async handlerDestroyPlan(id) {
    if (!this.state.isLoading) {
      this.toggleIsLoad(true);
      try {
        const access_token = await localStorage.getItem("access_token");
        const response = await api.delete(`/v1/${API_GUARD}/plan/${id}`, {
          headers: { Authorization: "Bearer " + access_token }
        });
        if (response.status && response.status === 200) {
          const { title, message } = response.data;
          this.activeAlert({ title, message });
        }
        this.getPlans()
      } catch (error) {
        if (error.response) {
          const { data } = error.response;
          const { errors } = data;
          switch (error.response.status) {
            case 400:
              this.activeAlert({ title: data.title, message: data.message });
              break;
            case 404:
              this.activeAlert({ title: data.title, message: data.message });
              break;
            case 422:
              for (let key in errors) {
                this.setState({
                  validate: {
                    ...this.state.validate,
                    [key]: {
                      message: errors[key],
                      isInvalid: true
                    }
                  }
                });
              }
              break;
            default:
              this.error();
          }
        }
        this.toggleIsLoad(false);
      }
    }
  }

  handlerHeaderCreatePlan() {
    const { history } = this.props;

    history.push("/admin/planos/adicionar");
  }

  handlerHeaderEditPlan(id) {
    const { history } = this.props;

    history.push(`/admin/planos/${id}/editar`);
  }

  render() {
    return (
      <div className={`${styles.container}`}>
        <Header title="Planos" description="Gerenciamento de Planos" />
        <div className={`${styles.body} ${styles.shadowBox}`}>
          <div className={styles.tableHeader}>
            <div className={styles.tableTitle}>
              <h2>Listagem de Planos</h2>
            </div>
            <br />
            <div className={styles.tableOption}>
              <Button text="Adicionar"
                type="button"
                onClick={() => { this.handlerHeaderCreatePlan() }}
              />
            </div>
          </div>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>#</th>
                <th>Nome</th>
                <th>Habilitado</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {
                this.state.isLoading ? (
                  <tr>
                    <th colSpan="5">Carregando listagem...</th>
                  </tr>
                ) :
                  (this.state.plans.length <= 0) ? (
                    <tr>
                      <th colSpan="5">Nenhum registro encontrado.</th>
                    </tr>
                  ) :
                    this.state.plans.map((plan, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{plan.name}</td>
                        <td>{plan.disabled ? "Não" : "Sim"}</td>
                        <td>
                          <div className={styles.tableButton}>
                            <Button text="Editar"
                              type="button"
                              onClick={() => { this.handlerHeaderEditPlan(plan.id) }}
                            />
                            <div className={styles.margin} />
                            <Button text="Excluir"
                              type="button"
                              onClick={() => { this.toggleConfirm(plan) }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))
              }
            </tbody>
          </table>
          <Modal
            isActive={this.state.isAlertOn}
            toggleAlert={this.toggleAlert}
            title={this.state.alertMessage.title}
            text={this.state.alertMessage.message}
          />
          <ModalConfirm
            isActive={this.state.isExclusionConfirmOn}
            toggleConfirm={this.toggleConfirm}
            handlerConfirm={() => { this.handlerConfirm(); this.toggleConfirm(null) }}
            title={this.state.modalConfirm.title}
            text={this.state.modalConfirm.message}
          />
        </div>
      </div>
    );
  }
}
